import type { IControl } from "maplibre-gl";
import { mapControlButton, mapZoomGroup, MINUS_ICON, PLUS_ICON } from "../map-embed-controls.ts";
import { t } from "../i18n/index.ts";
import type { MapCamera } from "./map-camera.ts";

/** Zoom +/- that always stops in-flight camera work before easing (avoids overlapping MapLibre eases). */
export class CameraZoomControl implements IControl {
  private readonly container = document.createElement("div");
  private readonly camera: MapCamera;

  constructor(camera: MapCamera) {
    this.camera = camera;
    this.container.className = "maplibregl-ctrl";
    const zoomOut = mapControlButton("route-map-zoom-btn", t("rt.map.zoomOut"), MINUS_ICON, () =>
      this.camera.zoomBy(-1),
    );
    const zoomIn = mapControlButton("route-map-zoom-btn", t("rt.map.zoomIn"), PLUS_ICON, () => this.camera.zoomBy(1));
    this.container.append(mapZoomGroup(zoomOut, zoomIn));
  }

  onAdd(): HTMLElement {
    return this.container;
  }

  onRemove(): void {
    this.container.remove();
  }
}
